import { lazy } from 'react';

import { audienceLoader } from '@p/audience/actions/audience.loader';
import { buildLoader } from '@p/audience/actions/build.loader';
import { categoryLoader } from '@p/audience/actions/category.loader';
import { resultLoader } from '@p/audience/actions/result.loader';

import { RouteGuard } from 'hoc/route-guard';
import { Route } from 'types/routes';
import { lazyNamed } from 'utilities/lazy-named';
import { s } from 'utilities/strings';

const AudienceDashboardPage = lazyNamed(() => import('pages/audience/dashboard'), 'AudienceDashboardPage');
const AudienceBuilderCreatePage = lazyNamed(() => import('pages/audience/create'), 'AudienceBuilderCreatePage');
const AudienceBuilderResultsPage = lazyNamed(() => import('pages/audience/results'), 'AudienceBuilderResultsPage');
const AudienceBuilderStudioPage = lazyNamed(() => import('pages/audience/studio'), 'AudienceBuilderStudioPage');
const ExternalListManagementPage = lazyNamed(
  () => import('pages/audience/external-list'),
  'ExternalListManagementPage'
);
const NlsManagementPage = lazy(() => import('pages/nls-dashboard/nls-management.page'));

export const abRoutes: Route = {
  children: [
    {
      children: [
        {
          element: <AudienceDashboardPage />,
          index: true,
          loader: categoryLoader,
        },
      ],
      element: <RouteGuard role={['admin']} />,
      icon: ['fas', 'bookmark'],
      includeInMenu: true,
      path: 'Root.children.AudienceBuilder.Dashboard',
      roles: ['admin'],
      title: s('Site.Studio'),
    },
    {
      children: [
        {
          children: [
            {
              children: [
                {
                  element: <AudienceBuilderCreatePage />,
                  index: true,
                },
                {
                  children: [
                    {
                      element: <AudienceBuilderCreatePage />,
                      id: 'shop-add',
                      loader: audienceLoader,
                      path: 'Root.children.AudienceBuilder.children.Build.children.add.children.id',
                    },
                  ],
                  path: 'Root.children.AudienceBuilder.children.Build.children.add.path',
                },
                {
                  children: [
                    {
                      element: <AudienceBuilderCreatePage />,
                      id: 'shop-load',
                      loader: buildLoader,
                      path: 'Root.children.AudienceBuilder.children.Build.children.load.children.id',
                    },
                  ],
                  path: 'Root.children.AudienceBuilder.children.Build.children.load.path',
                },
              ],
              icon: ['fas', 'toolbox'],
              includeInMenu: true,
              path: 'Root.children.AudienceBuilder.children.Build.path',
              roles: ['admin'],
              title: s('Site.Build'),
            },
            {
              children: [
                {
                  element: <AudienceBuilderResultsPage />,
                  index: true,
                },
                {
                  element: <AudienceBuilderResultsPage />,
                  loader: resultLoader,
                  path: 'Root.children.AudienceBuilder.children.Results.children.id',
                },
              ],
              path: 'Root.children.AudienceBuilder.children.Results.path',
            },
          ],
          element: <AudienceBuilderStudioPage />,
          loader: categoryLoader,
        },
      ],
      element: <RouteGuard role={['admin']} />,
    },
    {
      children: [
        {
          element: <ExternalListManagementPage />,
          index: true,
        },
      ],
      element: <RouteGuard role={['admin']} />,
      icon: ['fas', 'file-import'],
      includeInMenu: true,
      path: 'Root.children.AudienceBuilder.ExternalList',
      roles: ['admin'],
      title: s(['Site.External', 'Site.List'], { plural: true }),
    },
    {
      children: [
        {
          element: <NlsManagementPage />,
          index: true,
          loader: categoryLoader,
        },
      ],
      element: <RouteGuard role={['devops']} />,
      icon: ['fas', 'list-check'],
      includeInMenu: true,
      path: 'Root.children.AudienceBuilder.nlsOrders',
      roles: ['devops'],
      title: s('Site.Pages.NlsOrders.NlsOrderManagement'),
    },
  ],
  element: <RouteGuard role={['admin']} />,
  icon: ['fas', 'users'],
  includeInMenu: true,
  path: 'Root.children.AudienceBuilder.path',
  roles: ['admin'],
  title: s('Site.Audience'),
};
